'use client';

import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfTabs.module.scss';
import { Button, Card, Grid, Image, RichText } from '@/components';
import { Tabs, TabList, Tab, TabPanel } from 'react-aria-components';
import { useIsSSR } from 'react-aria';

let cx = classNames.bind(styles);

export default function AcfTabs(props) {
	const { tabsModule, attributes, clientId } = props;
	const className = attributes.className?.split(' ') || [];
	const style = {};
	style['--minTabHeightMobile'] = tabsModule.minimumHeightMobile ? `${tabsModule.minimumHeightMobile}px` : '0px';
	style['--minTabHeightDesk'] = tabsModule.minimumHeightDesktop ? `${tabsModule.minimumHeightDesktop}px` : '0px';

	let isSSR = useIsSSR();

	return (
		<>
			{!isSSR && (
				<Tabs id={attributes.anchor} className={cx(['ns_tabs', 'tabs', ...className])} style={style}>
					<TabList aria-label={tabsModule.tabsTitle} className={cx(['tab-list'])}>
						{tabsModule.tabs.map((tab, index) => (
							<Tab key={`${clientId}-tab-${index}`} id={`${clientId}-${index}`} className={cx(['tab'])}>
								<RichText html={tab.tabLabel} />
							</Tab>
						))}
					</TabList>
					{tabsModule.tabs.map((tab, index) => (
						<TabPanel key={`${clientId}-tab-panel-${index}`} id={`${clientId}-${index}`} className={cx(['tab-panel'])}>
							<Card className={cx(['ns_tab-card', 'tab-card'])} background={tabsModule.backgroundColor ? `bg-${tabsModule.backgroundColor}` : 'bg-neutral-lightest'}>
								<Grid colCount="12" alignItems="center" collapseMobile={true}>
									{tab.image && (
										<div className={cx(['ns_tab-image', 'tab-image'])}>
											<Image image={tab.image} fill={true} objectFit="cover" />
											<div className={cx(['ns_tab-image-mobile-bg'])}></div>
										</div>
									)}
									<div className={cx(['ns_tab-body', 'tab-body'])}>
										{tab.icon && (
											<div className={cx(['ns_tab-icon', 'tab-icon'])}>
												<Image image={tab.icon} fill={true} objectFit="contain" />
											</div>
										)}
										<RichText html={tab.tabContent} />
										{tab.cta?.title && tab.cta?.url && (
											<Button href={tab.cta.url} target={tab.cta.target} rel={tab.cta.target === '_blank' ? 'roreferrer noopener' : null} outlined={tab.ctaOutlined}>
												{tab.cta.title}
											</Button>
										)}
									</div>
								</Grid>
							</Card>
						</TabPanel>
					))}
				</Tabs>
			)}
		</>
	);
}

AcfTabs.fragments = {
	key: `AcfTabsFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfTabsFragment on AcfTabs {
			attributes {
				anchor
				className
			}
			tabsModule {
				backgroundColor
				minimumHeightDesktop
				minimumHeightMobile
				tabs {
					cta {
						target
						title
						url
					}
					ctaOutlined
					tabContent
					tabLabel
					icon {
						...ImageFragment
					}
					image {
						...ImageFragment
					}
				}
				tabsTitle
			}
			clientId
		}
	`,
};

AcfTabs.config = {
	name: 'AcfTabs',
};
AcfTabs.displayName = 'AcfTabs';
